import { HelmetProvider } from 'react-helmet-async';
import { Route, Routes } from 'react-router-dom';
import { SiteProvider } from './context/SiteContext';
import SiteShell from './components/SiteShell';
import PageResolver from './pages/PageResolver';

export default function App() {
  return <HelmetProvider><SiteProvider><SiteShell><Routes><Route path="*" element={<PageResolver />} /></Routes></SiteShell></SiteProvider></HelmetProvider>;
}
